module.exports = __webpack_public_path__ + "img/1521163777.59223180.jpg";